"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.newPropsAdapter = exports.legacyPropsAdapter = exports.isLegacyProps = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const moment_1 = __importDefault(require("moment"));
const isMoment = (value) => {
    return Boolean(value) && typeof value === "object" && "_isAMomentObject" in value;
};
const isDate = (value) => {
    return Boolean(value) && value instanceof Date;
};
const isLegacyProps = (props) => {
    const hasLegacyProps = isMoment(props.value) ||
        "disabledHours" in props ||
        "disabledHours" in props ||
        "disabledMinutes" in props ||
        "disabledSeconds" in props ||
        "onSelect" in props;
    const hasNewProps = isDate(props.value) ||
        "minTime" in props ||
        "maxTime" in props ||
        "onAccept" in props ||
        "onChange" in props ||
        "onError" in props;
    // TS should prevent this, but might happen in JS files
    if (hasLegacyProps && hasNewProps) {
        // eslint-disable-next-line no-console
        console.warn("TimePicker component is using a mismatch of legacy props and new props. This will most likely lead to errors.");
    }
    return hasLegacyProps;
};
exports.isLegacyProps = isLegacyProps;
// Adapts legacy gerudo component props (using Moment values and Antd interface) to MUI Picker props (using Dayjs values)
const legacyPropsAdapter = (legacyProps) => {
    const { value, disabledHours: getDisabledHours, disabledMinutes: getDisabledMinutes, disabledSeconds: getDisabledSeconds, onSelect } = legacyProps, otherProps = __rest(legacyProps, ["value", "disabledHours", "disabledMinutes", "disabledSeconds", "onSelect"]);
    const shouldDisableTime = (value, timeView) => {
        var _a, _b, _c;
        if (timeView === "hours") {
            const disabledHours = (_a = getDisabledHours === null || getDisabledHours === void 0 ? void 0 : getDisabledHours()) !== null && _a !== void 0 ? _a : [];
            return disabledHours.includes(value.hour());
        }
        if (timeView === "minutes") {
            const disabledMinutes = (_b = getDisabledMinutes === null || getDisabledMinutes === void 0 ? void 0 : getDisabledMinutes(value.hour())) !== null && _b !== void 0 ? _b : [];
            return disabledMinutes.includes(value.minute());
        }
        if (timeView === "seconds") {
            const disabledSeconds = (_c = getDisabledSeconds === null || getDisabledSeconds === void 0 ? void 0 : getDisabledSeconds(value.hour(), value.minute())) !== null && _c !== void 0 ? _c : [];
            return disabledSeconds.includes(value.second());
        }
        return false;
    };
    const adaptedProps = Object.assign({ value: value ? (0, dayjs_1.default)(value.toDate()) : undefined, shouldDisableTime, onAccept: onSelect && ((value) => onSelect(value ? (0, moment_1.default)(value.toDate()) : undefined)) }, otherProps);
    return adaptedProps;
};
exports.legacyPropsAdapter = legacyPropsAdapter;
// Adapts gerudo component props (using Date values) to MUI Picker props (using Dayjs values)
const newPropsAdapter = (props) => {
    const { value, minTime, maxTime, onAccept, onChange, onError, shouldDisableTime } = props, otherProps = __rest(props, ["value", "minTime", "maxTime", "onAccept", "onChange", "onError", "shouldDisableTime"]);
    const adaptedProps = Object.assign({ value: value && (0, dayjs_1.default)(value), minTime: minTime && (0, dayjs_1.default)(minTime), maxTime: maxTime && (0, dayjs_1.default)(maxTime), onAccept: onAccept && ((value) => { var _a; return onAccept((_a = value === null || value === void 0 ? void 0 : value.toDate()) !== null && _a !== void 0 ? _a : null); }), onChange: onChange && ((value) => { var _a; return onChange((_a = value === null || value === void 0 ? void 0 : value.toDate()) !== null && _a !== void 0 ? _a : null); }), onError: onError && ((error, value) => { var _a; return onError(error, (_a = value === null || value === void 0 ? void 0 : value.toDate()) !== null && _a !== void 0 ? _a : null); }), shouldDisableTime: shouldDisableTime && ((value, timeView) => shouldDisableTime(value.toDate(), timeView)) }, otherProps);
    return adaptedProps;
};
exports.newPropsAdapter = newPropsAdapter;
//# sourceMappingURL=helpers.js.map